import {updateObject} from "../../../shared/utils/updateObject";
import * as actionTypes from "./actionTypes";
import {intialStateModificheDetails} from "./helper";

const initialState = {
    tableData: [],
    tableLoading: false,
    count: 0,
    modificheDetails: intialStateModificheDetails,
    modificheDetailsLoading: false,
    downloadCsvLoading: false,
    downloadCsvForAuditLogLoading: false,
}

const setModificheData = (state, action) => {
    return updateObject(state, {tableData: action.payload, count: action.count});
}

const setModificheDataloading = (state, action) => {
    return updateObject(state, {tableLoading: action.value});
}

const setModificheDetailsData = (state, action) => {
    return updateObject(state, {modificheDetails: action.payload});
}

const setModificheDetailsLoading = (state, action) => {
    return updateObject(state, {modificheDetailsLoading: action.value});
}

const setDownloadCsv = (state, action) => {
    return updateObject(state, {downloadCsvLoading: action.value});
}

const setDownloadCsvForAuditLogId = (state, action) => {
    return updateObject(state, {downloadCsvForAuditLogLoading: action.value});
}

const modificheEffettuateReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_MODIFICHE_DATA:
            return setModificheData(state, action);
        case actionTypes.GET_MODIFICHE_DATA_LOADING:
            return setModificheDataloading(state, action);
        case actionTypes.GET_MODIFICHE_DETAILS_DATA:
            return setModificheDetailsData(state, action);
        case actionTypes.GET_MODIFICHE_DETAILS_LOADING:
            return setModificheDetailsLoading(state, action);
        case actionTypes.SET_DOWNLOAD_CSV:
            return setDownloadCsv(state, action);
        case actionTypes.SET_DOWNLOAD_CSV_FOR_AUDIT_LOG_DETAILS:
            return setDownloadCsvForAuditLogId(state, action);
        default:
            return state;
    }
}

export default modificheEffettuateReducer
